import { Link } from 'react-router-dom';

const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_first-gen-future/artifacts/skdpq6mr_ChatGPT%20Image%20May%206%2C%202026%20at%2009_33_50%20AM.png';

const Logo = ({ className = '', size = 'default' }) => {
  // size variants: small (navbar), default (footer/standalone)
  const sizeClass = size === 'small' ? 'h-16 md:h-20' : 'h-20 md:h-24';

  return (
    <Link
      to="/"
      data-testid="brand-logo"
      aria-label="Lantern Prep — home"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={LOGO_URL}
        alt="Lantern Prep"
        className={`${sizeClass} w-auto block select-none`}
        style={{ mixBlendMode: 'lighten' }}
        draggable={false}
      />
    </Link>
  );
};

export default Logo;
